import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableRow, Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  calculateTotals = (productData, factoryNameArray) => {
    const totals = {
      totalOrder: 0,
      totalRecivedQty: 0,
      totalShortSupply: 0,
    };

    factoryNameArray.forEach(column => {
      totals[column.factory] = 0;
    });

    productData.forEach(factory => {
      totals.totalOrder += factory.totalOrder || 0;
      totals.totalRecivedQty += factory.totalRecivedQty || 0;
      totals.totalShortSupply += factory.totalShortSupply || 0;

      factoryNameArray.forEach(column => {
        totals[column.factory] += factory[column.factory] || 0;
      });
    });

    return totals;
  };

  render() {
    const productData = this.props.productList;
    const factoryNameArray = this.props.factoryNameArray;
    const EnhancedTableHead = this.props.EnhancedTableHead;
    const classes = this.props.classes;
    const order = this.props.order;
    const orderBy = this.props.orderBy;
    const handleRequestSort = this.props.handleRequestSort;

    const totals = this.calculateTotals(productData, factoryNameArray);

    return (
      <div style={{ padding: '10px' }}>
        <h3><center><u>Purchasing History Report</u></center></h3>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer>
            <Table aria-label="caption table">
              <EnhancedTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={productData.length}
              />
              <TableBody>
                {productData.map((factory, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row" align="center">
                        {factory.orderDate}
                      </TableCell>
                      <TableCell component="th" scope="row" align="center">
                        {factory.skuCode}
                      </TableCell>
                      <TableCell component="th" scope="row" align="center">
                        {factory.skuDescription}
                      </TableCell>
                      {factoryNameArray.map((column) => {
                        const value = factory[column.factory];
                        return (
                          <TableCell align={column.tableCellAlign == 1 ? 'center' : column.tableCellAlign == 2 ? 'left' : 'right'} style={{ paddingRight: '30px' }}>
                            {value == undefined ? '-' : column.numeric == true ? parseFloat(value).toFixed(2) : parseFloat(value).toFixed(2)}
                          </TableCell>
                        );
                      })}
                      <TableCell component="th" scope="row" align='right'>
                        {factory.totalOrder > 0 ? parseFloat(factory.totalOrder).toFixed(2) : '-'}
                      </TableCell>
                      <TableCell component="th" scope="row" align='right'>
                        {factory.totalRecivedQty > 0 ? parseFloat(factory.totalRecivedQty).toFixed(2) : '-'}
                      </TableCell>
                      <TableCell component="th" scope="row" align='right'>
                        {factory.totalShortSupply == 0 ? '-' : parseFloat(factory.totalShortSupply).toFixed(2)}
                      </TableCell>
                      <TableCell component="th" scope="row" align='right'>
                        {factory.fillRate > 0 ? parseFloat(factory.fillRate).toFixed(2) : '-'}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
              <TableRow>
                <TableCell align="center" colSpan={3} style={{ fontWeight: "bold" }}>Total</TableCell>
                {factoryNameArray.map((column, idx) => (
                  <TableCell key={idx} align={column.tableCellAlign === 1 ? 'center' : column.tableCellAlign === 2 ? 'left' : 'right'} style={{ paddingRight: '30px', fontWeight: 'bold' }}>
                    {totals[column.factory] === undefined || totals[column.factory] === 0 ? '-' : parseFloat(totals[column.factory]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                ))}
                <TableCell component="th" scope="row" align='right' style={{ fontWeight: 'bold' }}>
                  {totals.totalOrder > 0 ? parseFloat(totals.totalOrder).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                </TableCell>
                <TableCell component="th" scope="row" align='right' style={{ fontWeight: 'bold' }}>
                  {totals.totalRecivedQty > 0 ? parseFloat(totals.totalRecivedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                </TableCell>
                <TableCell component="th" scope="row" align='right' style={{ fontWeight: 'bold' }}>
                  {totals.totalShortSupply === 0 ? '-' : parseFloat(totals.totalShortSupply).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell component="th" scope="row" align='right' style={{ fontWeight: 'bold' }}>
                </TableCell>
              </TableRow>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
